import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
// class ParentButton extends Component{
//
// }

const ButtonOverlay = styled.div`
  width: 100%;
  height: 100%;
  opacity: 0;
  position: absolute;
  left: 0;
`
const ButtonContainer = styled.button`
  background-color: #E2E8EC;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 116px;
  padding: 8px;
  border-radius: 4px;
  margin:4px 0 4px 0;
  width: 170px;
  border:none;
  font-family: Lato, "Helvetica Neue", Helvetica, Arial, sans-serif;
  position: relative;
  @media (min-width:1024px) {
    padding: 8px;
    border-radius: 4px;
    margin:4px 0 4px 0;
    width: 225px;
  }
  @media (min-width:1440px) {
    padding: 8px;
    border-radius: 4px;
    margin:4px 0 4px 0;
    width: 315px;
  }
`
const ParentName = styled.span`
  color: #EA3B3B;
  font-size: 12px;
  font-weight: bold;
  text-align: left;
  @media (min-width:1024px) {
    font-size: 14px;
  }
  @media (min-width:1440px) {
    font-size: 16px;
  }
`
const ParentRole = styled.span`
  color: rgba(74,74,74,.5);
  font-size: 10px;
  @media (min-width:1024px) {
    font-size: 12px;
  }
`
const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`
const InfoRow = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 4px 0 4px 0;
`
const IconInfo = styled.img`
  width:14px;
  height: 10px;
  margin-right: 8px;
  @media (min-width:1024px) {
    width:18px;
    height: 14px;
    margin-right: 8px;
  }
`
const Info = styled.span`
  font-size: 10px;
  color: rgba(74,74,74,1);
  font-weight: 600;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  max-width: 100px;
  @media (min-width:1024px) {
    font-size: 14px;
    max-width: 150px;
  }
  @media (min-width:1440px) {
    max-width: 240px;
  }
`

const RowIcon = styled.img`
  margin-right: 8px;
`

const ParentButton = props => (
  <ButtonContainer onClick={props.onClick} id={props.id} >
    {props.children
      ? props.children
      : <InfoContainer>
        <ParentName>{`${props.first_name} ${props.last_name_paternal}`}</ParentName>
        {/* <ParentRole>{props.userRole}</ParentRole> */}
        <InfoRow>
          <IconInfo src="/assets/email_icon.svg" />
          <Info>{props.email}</Info>
        </InfoRow>
        <InfoRow>
          <IconInfo src="/assets/contact_icon.svg" />
          <Info>{props.cellphone}</Info>
        </InfoRow>
      </InfoContainer>}
    {!props.disabled &&
    <RowIcon src="/assets/arrow_icon.svg" alt="go to" />
    }
  </ButtonContainer>
)

ParentButton.propTypes = {
  first_name: PropTypes.string,
  userRole: PropTypes.string,
  email: PropTypes.string,
  cellphone: PropTypes.number,
  children: PropTypes.object,
  height: PropTypes.string,
}

ParentButton.defaultProps = {
  first_name: '',
  children: null,
  userRole: '',
  height: '120px',
  email: '',
  cellphone: 0,
}

export default ParentButton



// WEBPACK FOOTER //
// ./src/Components/CustomButtons/ParentButton.jsx